import { render } from "./PowerballGame.vue?vue&type=template&id=efa9ad38"
import script from "./PowerballGame.vue?vue&type=script&lang=js"
export * from "./PowerballGame.vue?vue&type=script&lang=js"

import "./PowerballGame.vue?vue&type=style&index=0&id=efa9ad38&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.29_vue@3.2.13_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__